import styled from 'styled-components';

const StyledContainer = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 400px;
	padding: 26px 30px 28px;
	background-color: #111314;
	border-radius: 10px;
`;

const StyledDivider = styled.div`
	width: 100%;
	height: 1px;
	background-color: rgba(255, 255, 255, 0.1);
`;

const StyledBottomContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-top: 29px;
`;

const StyledTimerContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	img {
		width: 16px;
		height: 16px;
		user-select: none;
		pointer-events: none;
	}
`;

const StyledLogoContainer = styled.div`
	position: absolute;
	bottom: 60px;
	left: 50%;
	transform: translateX(-50%);

	img {
		width: 40px;
		height: 40px;
		opacity: 0.25;
		user-select: none;
		pointer-events: none;
	}
`;

export {
	StyledContainer,
	StyledDivider,
	StyledBottomContainer,
	StyledTimerContainer,
	StyledLogoContainer,
};
